// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "[data-v-b2988d38] .vx-card {\n  height: 100%;\n}\n", "",{"version":3,"sources":["webpack://./resources/js/components/views/rh/dashboard/widgets/RatingsInProgressWidget.vue"],"names":[],"mappings":"AACA;EAEQ,YAAY;AADpB","sourcesContent":["\n::v-deep {\n    .vx-card {\n        height: 100%;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
